import CONSTANTS from "./constants";

export const showShareContentViaBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_SHARE_CONTENT_VIA,
  payload: value,
});
export const showAboutThisCourseBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_ABOUT_THIS_COURSE,
  payload: value,
});

export const showCheckoutOptionsBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_CHECKOUT_OPTIONS,
  payload: value,
});

export const showVideoRestrictionsBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_VIDEO_RESTRICTIONS,
  payload: value,
});

export const showUpcomingLiveClassesBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_UPCOMING_LIVE_CLASSES,
  payload: value,
});

export const showApplyCouponBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_APPLY_COUPON,
  payload: value,
});
export const showApplyBundleBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_APPLY_BUNDLE,
  payload: value,
});
export const showApplyBundleReceiptBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_APPLY_BUNDLE_RECEIPT,
  payload: value,
});

export const showContentLockedBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_CONTENT_LOCKED,
  payload: value,
});

export const showWhatAreYouWatchingBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_WHAT_ARE_YOU_WATCHING,
  payload: value,
});

export const showTestIsLockedBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_TEST_IS_LOCKED,
  payload: value,
});

export const showSelectStateBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_SELECT_STATE,
  payload: value,
});

export const showSelectDynamicBundlingBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_SELECT_DYNAMIC_BUNDLING,
  payload: value,
});

export const showSelectAddressBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_SELECT_ADDRESS,
  payload: value,
});

export const showDeleteAddressPopupAction = (value) => ({
  type: CONSTANTS.POPUP_DELETE_ADDRESS,
  payload: value,
});

export const showRunningTightOnBudgetBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_RUNNING_TIGHT_ON_BUDGET,
  payload: value,
});

export const showCongratulationsBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_CONGRATULATIONS,
  payload: value,
});

export const showDueDateBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_DUE_DATE,
  payload: value,
});

export const showCourseLockedBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_COURSE_LOCKED,
  payload: value,
});

export const showPaymentFailedBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_PAYMENT_FAILED,
  payload: value,
});

export const setFreeTrialBottomsheetOpenViaTabSwitch = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_FREE_TRIAL_OPEN_VIA_TAB_SWITCH,
  payload: value,
});

export const showFreeTrialBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_FREE_TRAIL,
  payload: value,
});

export const showEnrollForFreeCourseBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_ENROLL_FOR_FREE_COURSE,
  payload: value,
});

export const showLockedFreeCourseBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_LOCKED_FREE_COURSE,
  payload: value,
});

export const showViewsExhaustedBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_VIEWS_EXHAUSTED,
  payload: value,
});
export const showCourseAccessRemoveBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_VIEW_COURSE_ACCESS_REMOVED,
  payload: value,
});

export const showDownloadVideoBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_DOWNLOAD_VIDEO,
  payload: value,
});

export const showExpirySoonBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_EXPIRY_SOON,
  payload: value,
});

export const showPaymentProcessingBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_PAYMENT_PROCESSING,
  payload: value,
});

export const showTestIsTemporarilyLockedBottomSheetAction = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_TEST_IS_TEMPORARILY_LOCKED,
  payload: value,
});

export const showTestIsTemporarilyLockedTimingBottomSheetAction = (
  value,
  dates
) => ({
  type: CONSTANTS.BOTTOMSHEET_TEST_IS_TEMPORARILY_LOCKED_TIMING,
  payload: value,
  dates,
});
export const showAnnouncementsAttachments = (value) => ({
  type: CONSTANTS.BOTTOMSHEET_ANNOUNCEMENTS_ATTACHMENTS,
  payload: value,
});
// export const isShowRunningTightOnBudgetBottomSheet = (value) => ({
//   type: CONSTANTS.BOTTOMSHEET_IS_SHOW_TIGHT_ON_BUDGET,
//   payload: value,
// });

export const toggleRecentActivitySuggestions = (value) => ({
  type: CONSTANTS.POPUP_REMOVE_SUGGESTIONS,
  payload: value,
});

// ACTION TO CLOSE ALL BOTTOMSHEETS
export const closeAllBottomSheetsAction = () => ({
  type: CONSTANTS.CLOSE_ALL_BOTTOMSHEET,
});

export const showFullScreenLoaderAction = (value) => ({
  type: CONSTANTS.SHOW_FULLSCREEN_LOADER,
  payload: value,
});

export const showPaymentLoaderAction = (value) => ({
  type: CONSTANTS.SHOW_PAYMENT_LOADER,
  payload: value,
});

export const showPaymentProcessingPopupAction = (value) => ({
  type: CONSTANTS.SHOW_POPUP_PAYMENT_PROCESSING,
  payload: value,
});

export const togglePaymentMethodsModalAction = (payload) => ({
  type: CONSTANTS.BOTTOMSHEET_PAYMENT_METHODS_MODAL,
  payload,
});

export const toggleMultiPaymentMethodModalAction = (payload) => ({
  type: CONSTANTS.BOTTOMSHEET_MULTI_PAYMENT_METHOD_MODAL,
  payload,
});
export const setPaymentMethodsAction = (payload) => ({
  type: CONSTANTS.BOTTOMSHEET_PAYMENT_METHODS_SET,
  payload,
});

export const setSelectedPaymentMethodAction = (payload) => ({
  type: CONSTANTS.BOTTOMSHEET_PAYMENT_METHODS_SELECT,
  payload,
});

export const setSelectedMultiPaymentMethodAction = (payload) => ({
  type: CONSTANTS.BOTTOMSHEET_MULTI_PAYMENT_METHODS_SELECT,
  payload,
});

export const courseFacultyListModalAction = (payload) => ({
  type: CONSTANTS.BOTTOMSHEET_COURSE_FACULTY_LIST,
  payload,
});

export const dynamicBundlingPopupAction = (payload) => ({
  type: CONSTANTS.DYNAMIC_BUNDLING_POPUP,
  payload,
});

export const setNotSupportedBottomsheet = (payload) => ({
  type: CONSTANTS.SET_SHOW_NOT_SUPPORTED_BOTTOMSHEET,
  payload,
});

export const setSocialLinksDataAction = (payload) => ({
  type: CONSTANTS.SET_SOCIAL_LINKS_DATA,
  payload,
});
export const toggleVideoBottomSheet = (payload) => ({
  type: CONSTANTS.TOGGLE_VIDEO_BOTTOM_SHEET,
  payload,
});

export const idfysContentLockAction = (payload) => ({
  type: CONSTANTS.IDFYS_LOCK_CONTENT,
  payload,
});

export const idfysPaymentRejectedAction = () => ({type:CONSTANTS.IS_PAYMENT_REJECTED})
